export default "__VITE_ASSET__Bct6r7px__"